import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import {apiBaseUrl} from "../config";

Vue.use(Vuex);
const instance = axios.create({
    baseURL: apiBaseUrl,
    // timeout: 30_000,
})


export const store = new Vuex.Store({
    state: {
        token: localStorage.getItem("access_token") || null,
        transportKeys: JSON.parse(localStorage.getItem("transport")) || [],
        info: {},
        visibleHeader: true,
        test: true,
        transportInfo: null,
        transports: [],
        loading: false,
        // token: localStorage.getItem('access_token') || null,
        // filter: 'all',
        // todos: [],
    },
    getters: {
        order(state, orderId) {
            return orderId;
        },
        loggedIn(state) {
            return state.token !== null;
        },
        getTransportInfo(state) {
            return state.transportInfo;
        },
        getTransportKeys(state) {
            console.log(state.transportKeys.length > 0, "klice - data");
            return state.transportKeys;
        },
        isTransportLoaded(state) {
            let keys = state.transportKeys;
            // console.log(Array.isArray(keys));
            // console.log(keys.length > 0)
            return Array.isArray(keys) && keys.length > 0;
        },
        loading(state) {
            return state.loading;
        }
    },
    mutations: {
        // auth
        retrieveToken(state, token) {
            state.token = token;
        },
        destroyToken(state) {
            state.token = null;
        },
        // uloží klíče přepravy
        setTransport(state, key) {
            if (localStorage) {
                var transport;
                if (!localStorage["transport"]) {
                    transport = [];
                } else {
                    transport = JSON.parse(localStorage["transport"]);
                }
                if (!(transport instanceof Array)) {
                    transport = [];
                }
                if (transport.indexOf(key) === -1) {
                    transport.push(key);
                }
                localStorage.setItem("transport", JSON.stringify(transport));
            }
            state.transportKeys = JSON.stringify(transport);
        },
        destroyTransport(state) {
            state.transports = [];
        },
        retrieveTransport(state, transports) {
            state.transports = transports;
        },
        cancelTransport(state) {
            state.transportKeys = [];
            state.transportInfo = null;
        },
        setOrderNotDelivery(state, data) {
            console.log(data);
        },
        setOrderHandOver(state, data) {
            console.log(data);
        },
        setOrderPickedUp(state, data) {
            console.log(data);
        },
        setOrderFinished(state) {
            // dokončeno
            state.transportKeys = [];
        },
        setOrderLoaded(state, data) {
            console.log(data);
        },
        checkOrder(state, data) {
            console.log(data);
        },
        isLoaded(state, data) {
            console.log(data);
        },
        retrieveTransportInfo(state, data) {
            state.transportInfo = data;
        },
        loading(state, data) {
            state.loading = data;
        }
    },
    actions: {
        // auth
        destroyToken(context) {
            // todo api
            instance.defaults.headers.common["Authorization"] =
                "Bearer " + context.state.token;

            if (context.getters.loggedIn) {
                context.commit("destroyToken");
                localStorage.removeItem("access_token");
                /*                return new Promise((resolve, reject) => {
                            instance.post('/logout')
                                .then(response => {
                                    localStorage.removeItem('access_token')
                                    context.commit('destroyToken')
                                    resolve(response)
                                    // console.log(response);
                                    // context.commit('addTodo', response.data)
                                })
                                .catch(error => {
                                    localStorage.removeItem('access_token')
                                    context.commit('destroyToken')
                                    reject(error)
                                })
                        })*/
            }
        },
        retrieveToken(context, credentials) {
            return new Promise((resolve, reject) => {
                instance
                    .post("/login", {
                        username: credentials.username,
                        password: credentials.password,
                        tokenName: "delivery-app",
                    })
                    .then((response) => {
                        const token = response.data.data.token;
                        localStorage.setItem("access_token", token);
                        console.log("krok1");
                        console.log(response);

                        return response;
                    })
                    .then((response) => {
                        const token = response.data.data.token;
                        context.commit("retrieveToken", token);
                        console.log("krok2");
                        console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        reject(error);
                    });
            });
        },
        // app
        checkTransport(context, key) {
            instance.defaults.headers.common["Authorization"] =
                "Bearer " + context.state.token;
            return new Promise((resolve, reject) => {
                // instance.defaults.headers.common['origin'] = 'localhost:8080'
                instance
                    .get("/check", {
                        params: {
                            key: key,
                        },
                    })
                    .then((response) => {
                        const key = response.data.data.key;
                        context.commit("setTransport", key);
                        resolve(response); // propise "dolu"!!!
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        async retrieveTransport(context, keys) {
            instance.defaults.headers.common["Authorization"] =
                "Bearer " + context.state.token;
            return await new Promise((resolve, reject) => {
                instance
                    .get("/get", {
                        params: {
                            key: keys, //context.state.transportKeys
                        },
                    })
                    .then((response) => {
                        context.commit("retrieveTransport", response.data.data);
                        context.dispatch("retrieveTransportInfo", keys);
                        resolve(response.data); // propise "dolu"!!!
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        cancelTransport(context) {
            return new Promise((resolve /*, reject*/) => {
                localStorage.removeItem("transport");

                context.commit("cancelTransport");
                resolve();
            });
        },
        async retrieveTransportInfo(context, keys) {
            instance.defaults.headers.common["Authorization"] =
                "Bearer " + context.state.token;
            return await new Promise((resolve, reject) => {
                instance
                    .get("/getTransportInfo", {
                        params: {
                            key: keys, //context.state.transportKeys
                        },
                    })
                    .then((response) => {
                        context.commit("retrieveTransportInfo", response.data.data);
                        console.log(response.data, "data");
                        resolve(response.data); // propise "dolu"!!!
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        finishTransport(context) {
            instance.defaults.headers.common["Authorization"] =
                "Bearer " + context.state.token;
            // todo oznacit za konec
            context.commit("destroyTransport");
            localStorage.removeItem("transport");
        },
        setOrderNotDelivery(context, payload) {
            instance.defaults.headers.common["Authorization"] =
                "Bearer " + context.state.token;
            return new Promise((resolve, reject) => {
                instance
                    .get("/order/notfound", {
                        params: {
                            id: payload.id,
                            key: payload.key,
                            itemId: payload.itemId,
                        },
                    })
                    .then((response) => {
                        context.commit("setOrderNotDelivery", response.data);
                        resolve(response.data); // propise "dolu"!!!
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        checkOrder(context, payload) {
            instance.defaults.headers.common["Authorization"] =
                "Bearer " + context.state.token;
            // instance.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
            return new Promise((resolve, reject) => {
                instance
                    .get("/order/check", {
                        params: {
                            id: payload.orderId,
                            key: payload.key,
                        },
                        headers: {
                            // 'Content-Type': 'application/x-www-form-urlencoded', // neodkomentovavat!!!
                        },
                    })
                    .then((response) => {
                        context.commit("checkOrder", response.data);
                        resolve(response.data); // propise "dolu"!!!
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        async isLoadedAll(context, keys) {
            instance.defaults.headers.common["Authorization"] =
                "Bearer " + context.state.token;
            // instance.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
            return new Promise((resolve, reject) => {
                instance
                    .get("/isLoaded", {
                        params: {
                            key: keys, //context.state.transportKeys//payload.key,
                        },
                        headers: {
                            // 'Content-Type': 'application/x-www-form-urlencoded', // neodkomentovavat!!!
                        },
                    })
                    .then((response) => {
                        context.commit("isLoaded", response.data);
                        resolve(response.data); // propise "dolu"!!!
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        setOrderLoaded(context, payload) {
            console.log(payload);
            instance.defaults.headers.common["Authorization"] =
                "Bearer " + context.state.token;
            instance.defaults.headers.common["Content-Type"] =
                "application/x-www-form-urlencoded";
            return new Promise((resolve, reject) => {
                instance
                    .patch("/order/loaded/" + payload.orderId, {
                        params: {
                            key: payload.key,
                        },
                        headers: {
                            // 'Content-Type': 'application/x-www-form-urlencoded', // neodkomentovavat!!!
                        },
                    })
                    .then((response) => {
                        context.commit("setOrderLoaded", response.data);
                        resolve(response.data); // propise "dolu"!!!
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        setOrderHandOver(context, payload) {
            instance.defaults.headers.common["Authorization"] =
                "Bearer " + context.state.token;
            instance.defaults.headers.common["Content-Type"] =
                "application/x-www-form-urlencoded";
            return new Promise((resolve, reject) => {
                instance
                    .patch("/order/handover/" + payload.id, {
                        params: {
                            data: payload.data,
                            id: payload.id,
                            key: payload.key,
                            itemId: payload.itemId,
                            note: payload.note,
                        },
                        headers: {
                            // 'Content-Type': 'application/x-www-form-urlencoded', // neodkomentovavat!!!
                        },
                    })
                    .then((response) => {
                        context.commit("setOrderHandOver", response.data);
                        resolve(response.data); // propise "dolu"!!!
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        setOrderPickedUp(context, payload) {
            instance.defaults.headers.common["Authorization"] =
                "Bearer " + context.state.token;
            instance.defaults.headers.common["Content-Type"] =
                "application/x-www-form-urlencoded";
            return new Promise((resolve, reject) => {
                instance
                    .patch("/pickedUp", {
                        params: {
                            key: context.state.transportKeys,
                            notification: payload.notification,
                            sms: true,
                        },
                        headers: {
                            // 'Content-Type': 'application/x-www-form-urlencoded', // neodkomentovavat!!!
                        },
                    })
                    .then((response) => {
                        context.commit("setOrderPickedUp", response.data);
                        resolve(response.data); // propise "dolu"!!!
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        setOrderFinished(context) {
            instance.defaults.headers.common["Authorization"] =
                "Bearer " + context.state.token;
            instance.defaults.headers.common["Content-Type"] =
                "application/x-www-form-urlencoded";
            return new Promise((resolve, reject) => {
                instance
                    .patch("/finished", {
                        params: {
                            key: context.state.transportKeys,
                        },
                        headers: {
                            // 'Content-Type': 'application/x-www-form-urlencoded', // neodkomentovavat!!!
                        },
                    })
                    .then((response) => {
                        localStorage.removeItem("transport");
                        context.commit("setOrderFinished");
                        resolve(response.data); // propise "dolu"!!!
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        retrieveInfo(context) {
            instance.defaults.headers.common["Authorization"] =
                "Bearer " + context.state.token;
            return new Promise((resolve, reject) => {
                instance
                    .get("/info")
                    .then((response) => {
                        context.commit("retrieveInfo", response.data);
                        resolve(response); // propise "dolu"!!!
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        timeout(ms) {
            return new Promise((resolve) => {
                window.setTimeout(resolve, ms);
            });
        },
    },
});

instance.interceptors.request.use(
    (config) => {
        store.commit('loading', true);
        return config;
    },
    (error) => {
        // Handle request error
        store.commit('loading', false);
        return Promise.reject(error);
    }
);
instance.interceptors.response.use(
    (response) => {
        // Set loading to false after receiving a response
        store.commit('loading', false);
        return response;
    },
    (error) => {
        // Set loading to false if the response has an error
        store.commit('loading', false);
        return Promise.reject(error);
    }
);
